// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden__1_pcm","textEmphasis":"index_textEmphasis__cRBVr","wrapper":"index_wrapper__4mCpP","topArea":"index_topArea__Mq7Pu"};